import React, { useEffect, useState, useRef } from 'react';
import "./MessageList.css";
import { useMessageContext } from '../../../context/MessageContext';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const MessageList = ({ id }) => {
    const [messages, setMessages] = useState([]);
    const { updateMessages } = useMessageContext();
    const messagesEndRef = useRef(null);

    const fetchMessages = () => {
        axiosInstance.get(`chat/owner_dialog/${id}/history?is_user=false`)
            .then(response => {
                setMessages(response.data);
            })
            .catch(error => {
                logger.error('Error fetching messages:', error);
            });
    };

    const updateMessageStatus = () => {
        axiosInstance.post(`chat/owner_dialog/${id}/status?is_user=false`)
            .then(response => {
                logger.debug('Message status updated');
            })
            .catch(error => {
                logger.error('Error updating message status:', error);
            });
    };

    useEffect(() => {
        fetchMessages(); 
        const fetchMessagesInterval = setInterval(() => {
            fetchMessages(); 
        }, 1000);

        const updateStatusInterval = setInterval(() => {
            updateMessageStatus(); 
        }, 1000);

        return () => {
            clearInterval(fetchMessagesInterval);
            clearInterval(updateStatusInterval);
        };
    }, [id, updateMessages]);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    };

    return (
        <div className='messageList'>
            {messages.map(message => (
                <div key={message.id} className={`message ${message.is_user_sender ? 'sent' : 'received'}`}>
                    {message.status === false && message.is_user_sender && <div className={`statusIndicator sent`}></div>}
                    {message.status === false && !message.is_user_sender && <div className={`statusIndicator received`}></div>}
                    <div className='messageText'>{message.message}</div>
                    <div className='timestamp'>{new Date(message.timestamp * 1000).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}</div>
                </div>
            ))}
            <div ref={messagesEndRef} /> {/* Реф для прокрутки вниз */}
        </div>
    );
};

export default MessageList;
